(function () {
  "use strict";

  var InlineBlot = Quill.import("blots/inline");
  var EmbedBlot = Quill.import("blots/embed");

  class TelephoneBlot extends EmbedBlot {}

  TelephoneBlot.tagName = "SPARKLE-TEL";
  TelephoneBlot.blotName = "telephone";

  TelephoneBlot.create = function (value) {
    if (value.telephone) {
      value = value.telephone;
    }

    var domNode = EmbedBlot.create.call(this, value);
    domNode.dataset.id = value.id;
    domNode.dataset.number = value.number;
    domNode.innerText = value.number;
    domNode.setAttribute("draggable", false);

    jQuery(domNode).on("click", function (e) {
      e.preventDefault();
      var blot = Quill.find(e.target.closest("sparkle-tel"));

      jQuery(domNode).trigger("quill:blot:telephone:click", blot);
    });

    return domNode;
  };

  TelephoneBlot.formats = function (domNode) {
    var number = domNode.dataset.number;

    if (!number || number === "") {
      number = domNode.innerText;
    }

    return {
      telephone: {
        id: domNode.dataset.id,
        number: number,
      },
    };
  };

  TelephoneBlot.prototype.deleteAt = function deleteAt() {
    this.remove();
  };

  TelephoneBlot.prototype.format = function (name, value) {
    this.domNode.dataset.id = value.id;
    this.domNode.dataset.number = value.number;
    this.domNode.innerText = value.number;
  };

  TelephoneBlot.prototype.index = function () {
    return 1;
  };

  Quill.register(TelephoneBlot);

  class LinkBlot extends InlineBlot {}

  LinkBlot.tagName = "A";
  LinkBlot.blotName = "link";

  LinkBlot.create = function (value) {
    var domNode = InlineBlot.create.call(this, value);

    LinkBlot.formatNode(domNode, value);

    jQuery(domNode).on("click", function (e) {
      e.preventDefault();
      var blot = Quill.find(e.target.closest("a"));
      jQuery(domNode).trigger("quill:blot:link:click", blot);
    });

    return domNode;
  };

  LinkBlot.sanitize = function (url) {
    var anchor = document.createElement("a");
    anchor.href = url;
    var protocol = anchor.href.slice(0, anchor.href.indexOf(":"));
    if (["http", "https", "mailto", "tel", "sparkle"].indexOf(protocol) > -1) {
      return url;
    } else {
      return "about:blank";
    }
  };

  LinkBlot.formats = function (domNode) {
    return {
      url: domNode.getAttribute("href"),
      documentTitle: domNode.getAttribute("data-document-title") === "true",
      style: domNode.getAttribute("class"),
      behaviour: domNode.getAttribute("data-link-behaviour"),
      target: domNode.getAttribute("target"),
    };
  };

  LinkBlot.prototype.format = function (name, value) {
    if (name !== this.statics.blotName || !value) {
      return InlineBlot.prototype.format.call(this, name, value);
    }

    LinkBlot.formatNode(this.domNode, value);
  };

  LinkBlot.formatNode = function (domNode, value) {
    var url = value ? LinkBlot.sanitize(value.url) : "";
    var documentTitle = value ? value.documentTitle : false;

    domNode.setAttribute("href", url);
    domNode.setAttribute("data-document-title", documentTitle);
    domNode.setAttribute("draggable", false);

    if (value.target) {
      domNode.setAttribute("target", value.target);
    } else {
      domNode.removeAttribute("target");
    }

    if (value.style) {
      domNode.setAttribute("class", value.style);
    } else {
      domNode.removeAttribute("class");
    }

    if (value.behaviour) {
      domNode.setAttribute("data-link-behaviour", value.behaviour);
    } else {
      domNode.removeAttribute("data-link-behaviour");
    }
  };

  Quill.register(LinkBlot, true);

  class SmartBlot extends EmbedBlot {}

  SmartBlot.tagName = "SNIPPET";
  SmartBlot.blotName = "snippet";

  SmartBlot.create = function (value) {
    if (value.snippet) {
      value = value.snippet;
    }

    var domNode = EmbedBlot.create.call(this, value);
    domNode.innerText = value.placeholder;
    domNode.setAttribute("draggable", false);
    domNode.setAttribute("data-params", value.params || "{}");
    domNode.setAttribute("data-type", value.type);
    if (value.type === "assessment") {
      domNode.setAttribute("class", "btn-mini");
    }

    jQuery(domNode).on("click", function (e) {
      e.preventDefault();
      var blot = Quill.find(e.target.closest("snippet"));
      jQuery(domNode).trigger("quill:blot:smart:click", blot);
    });

    return domNode;
  };

  SmartBlot.formats = function (domNode) {
    return {
      snippet: {
        placeholder: domNode.innerText,
        type: domNode.dataset.type,
        params: domNode.dataset.params,
      },
    };
  };

  SmartBlot.prototype.deleteAt = function deleteAt() {
    this.remove();
  };

  SmartBlot.prototype.format = function (name, value) {
    this.domNode.dataset.placeholder = value.placeholder;
    this.domNode.dataset.type = value.type;
    this.domNode.dataset.params = value.params;

    this.domNode.innerText = value.placeholder;

    if (value.type === "assessment") {
      this.domNode.setAttribute("class", "btn-mini");
    }
  };

  SmartBlot.prototype.index = function () {
    return 1;
  };

  Quill.register(SmartBlot);

  class MarkBlot extends InlineBlot {}

  MarkBlot.tagName = "MARK";
  MarkBlot.blotName = "mark";

  MarkBlot.formats = function (domNode) {
    return true;
  };

  Quill.register(MarkBlot);

  Sparkle.PageBuilder.Wysiwyg = _.extend(
    {
      Blots: {
        SmartBlot: SmartBlot,
        TelephoneBlot: TelephoneBlot,
        LinkBlot: LinkBlot,
      },
    },
    Sparkle.PageBuilder.Wysiwyg,
  );
})();
